import { useCallback, useEffect, useState } from "react";
import api from "@/api"; // В src/api.js есть export default api

export default function useCategories() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/material-categories");
      const list = Array.isArray(res.data) ? res.data : [];
      setData(list.map((r) => ({ ...r, children: (r.children || []).map((c) => ({ ...c })) })));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchList(); }, [fetchList]);

  const reload = useCallback(fetchList, [fetchList]);

  const createRoot = useCallback(async (name) => {
    await api.post("/material-categories", { name });
  }, []);

  const createChild = useCallback(async (parentId, name) => {
    await api.post("/material-categories", { name, parent_id: parentId });
  }, []);

  const updateCategoryName = useCallback(async (id, name) => {
    // оптимистическое обновление
    setData((prev) => {
      const copy = JSON.parse(JSON.stringify(prev));
      const walk = (arr) => {
        for (const node of arr) {
          if (node._id === id) { node.name = name; return true; }
          if (node.children && walk(node.children)) return true;
        }
        return false;
      };
      walk(copy);
      return copy;
    });
    await api.put(`/material-categories/${id}`, { name });
  }, []);

  const removeCategory = useCallback(async (id) => {
    await api.delete(`/material-categories/${id}`);
  }, []);

  return {
    data,
    loading,
    reload,
    createRoot,
    createChild,
    updateCategoryName,
    removeCategory,
  };
}
